module.exports = __webpack_public_path__ + "static/media/blackjack-1.85b94cac.JPG";